import axios from "../utils/axios";
import { storage } from "../utils/helpers/storage";
import { jwtDecode } from "jwt-decode";

export const getKioskClientByDomain = async (domain) => {
  domain = domain
    .toLowerCase()
    .replace(/[^a-z0-9-]/g, "") // Remove invalid characters
    .replace(/^-+|-+$/g, "") // Remove leading or trailing hyphens
    .replace(/-+/g, "-") // Ensure only one hyphen is present
    .trim();
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_SERVICES_API}/services/client/find?domain=${domain}`,
      {
        headers: {
          Authorization: "",
          "locus-region": "",
          "locus-domain": "",
        },
      },
    );
    storage.setDomain(response?.data?.domain);
    storage.setRegion(response?.data?.region);
    storage.setUserRegion(response?.data?.region);
    return response.data;
  } catch (error) {
    return error;
  }
};

export const kioskLogin = async (username, password) => {
  if (!username || !password) return;
  try {
    const decoded = storage.getAccessToken()
      ? jwtDecode(storage.getAccessToken())
      : null;
    const response = await axios.post(
      `${process.env.REACT_APP_AUTH_API}/oauth/token?grant_type=password`,
      {},
      {
        headers: {
          Authorization: `Basic ${btoa(`${username}:${password}`)}`,
          "locus-domain": decoded?.domain
            ? decoded.domain
            : storage.getDomain(),
          "locus-region": storage.getUserRegion()
            ? storage.getUserRegion()
            : storage.getRegion(),
        },
      },
    );
    let data = response?.data;
    if (data.access_token && data.refresh_token) {
      storage.setAccessToken(data.access_token);
      storage.setRefreshToken(data.refresh_token);

      axios.defaults.headers.common.Authorization = `Bearer ${data.access_token}`;
      axios.defaults.headers["locus-domain"] = storage.getDomain()
        ? storage.getDomain()
        : null;
      axios.defaults.headers["locus-region"] = storage.getRegion()
        ? storage.getRegion()
        : null;
    }
    return data;
  } catch (error) {
    return error;
  }
};

export const hasCarousel = (deviceResponse) => {
  if (!deviceResponse || typeof deviceResponse !== "object") {
    return false;
  }

  return Boolean(
    deviceResponse?.carousel &&
      Array.isArray(deviceResponse?.carousel) &&
      deviceResponse?.carousel?.length > 0,
  );
};

export const getCarouselDisplayDuration = (duration) => {
  if (typeof duration !== "number" || isNaN(duration)) {
    return 60000;
  }
  const allowed = [60000, 90000, 120000, 180000];
  for (let i = 0; i < allowed.length; i++) {
    if (duration <= allowed[i]) {
      return allowed[i];
    }
  }
  return 180000;
};
